import { UpOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';
import React, { useEffect, useState } from 'react';
import Wrapper from './style';

const { Panel } = Collapse;

const getDimensions = (element) => {
  const height = element?.getBoundingClientRect()?.height;
  const { offsetTop } = element;
  const offsetBottom = offsetTop + height;
  return { height, offsetTop, offsetBottom };
};

const Index = (props) => {
  const { activeMenu, menus, onClickStep } = props;
  const [visibleSection, setVisibleSection] = useState();

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const subMenus = activeMenu?.subMenu;
      const selected = subMenus.find(({ key }) => {
        const element = document.getElementById(key);
        if (element) {
          const { offsetBottom } = getDimensions(element);
          return scrollPosition < offsetBottom;
        }
        return element;
      });

      if (selected && selected.key !== visibleSection) {
        setVisibleSection(selected.key);
      } else if (!selected && visibleSection) {
        setVisibleSection(undefined);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [visibleSection, activeMenu]);

  return (
    <Wrapper>
      <Collapse
        ghost
        activeKey={[activeMenu.key]}
        expandIconPosition="right"
        expandIcon={({ isActive }) => {
          return <UpOutlined rotate={isActive ? 0 : 180} />;
        }}
      >
        {menus.map((item) => {
          const isActive = item?.key === activeMenu?.key;
          const header = (
            <div className={`component_header_menu ${isActive && 'active'}`}>
              {item.icon}
              <div className="font-paragraph_medium">{item.title}</div>
            </div>
          );
          return (
            <Panel header={header} key={item.key}>
              {item.subMenu.map((sub) => {
                const isActiveItem = sub?.key === visibleSection;
                return (
                  <div
                    key={sub.key}
                    aria-hidden
                    onClick={() => {
                      onClickStep(sub);
                    }}
                    className={`component_sub_menu ${
                      isActiveItem && 'active'
                    } ${sub?.icon && 'with_icon'}`}
                  >
                    <div className="font-caption_medium black2 ">
                      {sub.title}
                      {sub?.icon}
                    </div>
                  </div>
                );
              })}
            </Panel>
          );
        })}
      </Collapse>
    </Wrapper>
  );
};

export default Index;
